import React from 'react';
import styled from 'styled-components';

import Icon from './Icon';

const StyledLogo = styled.svg`
    
    & .logo-www,
    .logo-love {
      fill: ${props => props.theme.palette.common.text};
    }

    & .logo-stoff {
      fill: ${props => props.theme.palette.common.primary};
    }

    & .logo-heart {
      fill: ${props => props.theme.palette.common.secondary};
    }
`;

const StyledLogoFlex = styled.div`
    display: inline;
    border-bottom: 1px dashed ${props => props.theme.palette.secondary[600]};
`;

const StyledSchnoffle = styled.span`
    color: ${props => props.theme.palette.secondary[600]};
    font-family:  ${props => props.theme.serif};
    font-size: 2.1rem;
    margin-left: .35rem;
    line-height: 1;
    font-weight: 700;
`;

const StyledSubheadline = styled.span`
    display: block;
    color: ${props => props.theme.palette.secondary[600]};
    font-family:  ${props => props.theme.font};
    font-size: 0.9rem;
    margin-left: .35rem;
    margin-top: 0.15em;
    line-height: 1;
    font-weight: normal;
`;

export const SVGLogo = () => (
    <StyledLogo
        className='stolo-logo'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 743 117.1'
    >
        <path
            d='M82.3 41.4h2.1L62.7 91.1h-1.7L48.9 63.2 36.7 91.1h-1.7L13.3 41.4h2.1l20.5 46.9 12-27.5 -8.3-19.3h2l7.4 16.8 7.4-16.8h2l-8.3 19.3 12 27.5L82.3 41.4z'
        />
        <path
            d='M154.5 41.4h2.1l-21.7 49.6h-1.7l-12.1-27.8 -12.1 27.8h-1.7L85.4 41.4h2.1l20.5 46.9 12-27.5 -8.3-19.3h2l7.4 16.8 7.4-16.8h2l-8.3 19.3 12 27.5L154.5 41.4z'
        />
        <path
            d='M225.9 41.4h2.1l-21.7 49.6h-1.7l-12.1-27.8 -12.1 27.8h-1.7l-21.7-49.6h2.1l20.5 46.9 12-27.5 -8.3-19.3h2l7.4 16.8 7.4-16.8h2l-8.3 19.3 12 27.5L225.9 41.4z'
        />
        <path
            d='M287.9 86.2c0.4 0.8 0.9 1.5 1.4 2 0.5 0.5 1 0.9 1.5 1.3v2c-5.7-0.2-9.5-0.4-11.3-0.4 -2 0-6.4 0.1-13.1 0.4v-2c1.8 0 2.7-0.6 2.7-1.8 0-0.4-0.1-0.9-0.4-1.4l-8.2-17.3c-0.4-0.7-0.8-1.2-1.3-1.5 -0.5-0.3-1-0.5-1.7-0.6V82.7c0 2.5 0.4 4.3 1.2 5.3 0.8 1 2.1 1.4 4.1 1.4v2c-6.7-0.2-11.1-0.4-13.2-0.4 -2.1 0-6.8 0.1-14 0.4v-2c1.9 0 3.3-0.5 4.1-1.4 0.8-1 1.2-2.7 1.2-5.3V29.7c0-2.9-0.4-4.9-1.2-6.2 -0.8-1.3-2.1-2-4.1-2V19.6c1.9 0.2 3.9 0.3 5.8 0.3 6.5 0 11.9-0.4 16.2-1.3v46.6c1.7 0 3.1-0.5 4-1.4l7.2-6.7c2.2-2 3.3-4 3.3-6.1 0-1.6-0.7-3-2.1-4.1 -1.4-1.1-3.2-1.8-5.4-2v-1.9c3.5 0.2 7.3 0.3 11.2 0.3 6.1 0 10.3-0.1 12.8-0.3v1.9c-4.3 1.2-8.9 4.2-13.8 9.1l-2.4 2.4 14.8 28.1C287.2 84.9 287.5 85.4 287.9 86.2z'
        />
        <path
            d='M314.6 82.7c0 2.5 0.4 4.3 1.2 5.3 0.8 1 2.1 1.4 4.1 1.4v2c-6.7-0.2-11.1-0.4-13.2-0.4 -2.1 0-6.8 0.1-14 0.4v-2c1.9 0 3.3-0.5 4.1-1.4 0.8-1 1.2-2.7 1.2-5.3v-29.5c0-2.9-0.4-4.9-1.2-6.2 -0.8-1.3-2.1-2-4.1-2v-2c2 0.2 3.9 0.3 5.8 0.3 6.5 0 11.9-0.4 16.2-1.3V82.7zM313.1 20.6c1.8 1.4 2.7 3.4 2.7 6s-0.9 4.6-2.7 6c-1.8 1.4-4.3 2-7.5 2 -3.3 0-5.8-0.7-7.5-2 -1.7-1.4-2.6-3.4-2.6-6s0.9-4.6 2.6-6c1.7-1.4 4.3-2 7.5-2C308.9 18.6 311.4 19.2 313.1 20.6z'
        />
        <path
            d='M349.8 42.5c2.1 0.5 3.8 1.1 4.9 1.7 0.7 0.4 1.2 0.6 1.7 0.6 1.3 0 2.1-1 2.3-3h1.9c-0.2 3.2-0.4 8.8-0.4 16.8h-1.9c-0.5-4.1-1.7-7.6-3.5-10.4 -1.8-2.8-4.5-4.2-8-4.2 -1.6 0-2.9 0.5-3.9 1.4 -1.1 0.9-1.6 2.2-1.6 3.8 0 2 0.7 3.9 2 5.4 1.4 1.6 3.5 3.5 6.4 5.8 0.1 0.1 1 0.8 2.7 2.1 3.5 2.9 6 5.4 7.6 7.6 1.6 2.2 2.4 4.9 2.4 8.2 0 2.7-0.8 5.2-2.5 7.4 -1.7 2.2-4 3.9-6.8 5.1 -2.9 1.2-6 1.8-9.5 1.8 -3.9 0-7.1-0.8-9.6-2.3 -1.1-0.6-1.9-1-2.6-1.2 -0.7-0.2-1.4-0.4-2-0.4 -1.2 0-2 1.1-2.6 3.3h-1.9c0.2-3.5 0.4-9.7 0.4-18.6h1.9c0.6 5.1 1.9 9.2 4.1 12.3 2.2 3.1 4.9 4.7 8.2 4.7 1.6 0 2.8-0.4 3.9-1.3 1-0.9 1.5-2.1 1.5-3.8 0-1.7-0.4-3.3-1.1-4.7 -0.7-1.4-1.6-2.6-2.6-3.7 -1-1.1-2.7-2.7-5-4.7 -2.6-2.4-4.6-4.3-6-5.8 -1.4-1.4-2.5-3.1-3.5-5 -1-1.9-1.4-4-1.4-6.3 0-2.7 0.8-5 2.4-7.1 1.6-2 3.8-3.6 6.4-4.7 2.7-1.1 5.6-1.6 8.7-1.6C345.3 41.8 347.6 42 349.8 42.5z'
        />
        <path
            d='M393.7 42.5c2.1 0.5 3.8 1.1 4.9 1.7 0.7 0.4 1.2 0.6 1.7 0.6 1.3 0 2.1-1 2.3-3h1.9c-0.2 3.2-0.4 8.8-0.4 16.8h-1.9c-0.5-4.1-1.7-7.6-3.5-10.4 -1.8-2.8-4.5-4.2-8-4.2 -1.6 0-2.9 0.5-3.9 1.4 -1.1 0.9-1.6 2.2-1.6 3.8 0 2 0.7 3.9 2 5.4 1.4 1.6 3.5 3.5 6.4 5.8 0.1 0.1 1 0.8 2.7 2.1 3.5 2.9 6 5.4 7.6 7.6 1.6 2.2 2.4 4.9 2.4 8.2 0 2.7-0.8 5.2-2.5 7.4 -1.7 2.2-4 3.9-6.8 5.1 -2.9 1.2-6 1.8-9.5 1.8 -3.9 0-7.1-0.8-9.6-2.3 -1.1-0.6-1.9-1-2.6-1.2 -0.7-0.2-1.4-0.4-2-0.4 -1.2 0-2 1.1-2.6 3.3h-1.9c0.2-3.5 0.4-9.7 0.4-18.6h1.9c0.6 5.1 1.9 9.2 4.1 12.3 2.2 3.1 4.9 4.7 8.2 4.7 1.6 0 2.8-0.4 3.9-1.3 1-0.9 1.5-2.1 1.5-3.8 0-1.7-0.4-3.3-1.1-4.7 -0.7-1.4-1.6-2.6-2.6-3.7 -1-1.1-2.7-2.7-5-4.7 -2.6-2.4-4.6-4.3-6-5.8 -1.4-1.4-2.5-3.1-3.5-5 -1-1.9-1.4-4-1.4-6.3 0-2.7 0.8-5 2.4-7.1 1.6-2 3.8-3.6 6.4-4.7 2.7-1.1 5.6-1.6 8.7-1.6C389.3 41.8 391.6 42 393.7 42.5z'
        />
        <path
            d='M451.6 76.3l1.6 0.6c-1.4 4.3-3.7 8.1-6.9 11.2 -3.3 3.1-7.4 4.7-12.5 4.7 -6.5 0-11.7-2-15.6-6.1 -3.9-4-5.9-10.5-5.9-19.4 0-8.5 2.2-14.9 6.6-19.1s10.2-6.4 17.4-6.4c11.7 0 17.6 7 17.6 20.9h-24c-0.1 0.7-0.1 1.9-0.1 3.4 0 6 1 10.2 3.1 12.8 2.1 2.5 4.6 3.8 7.6 3.8C444.9 82.6 448.6 80.5 451.6 76.3zM429.4 60.8h10.8c0.1-5-0.3-9-1.1-12.2 -0.8-3.2-2-4.8-3.6-4.8C432 43.9 430 49.5 429.4 60.8z'
        />
        <path
            d='M504.5 45.5c0.9 1.1 1.6 2.6 2.1 4.5s0.7 4.4 0.7 7.5V82.7c0 2.5 0.4 4.3 1.2 5.3 0.8 1 2.1 1.4 4.1 1.4v2c-6.7-0.2-11.1-0.4-13-0.4 -2.1 0-6.5 0.1-13.2 0.4v-2c1.6 0 2.7-0.5 3.4-1.4 0.6-1 0.9-2.7 0.9-5.3V52.5c0-2-0.4-3.5-1.1-4.4 -0.7-1-1.9-1.4-3.5-1.4 -1.8 0-3.4 0.6-4.7 1.9 -1.3 1.3-2 2.9-2 4.8V82.7c0 2.5 0.3 4.3 0.9 5.3 0.6 1 1.7 1.4 3.4 1.4v2c-6.2-0.2-10.3-0.4-12.3-0.4 -2.1 0-6.8 0.1-14 0.4v-2c1.9 0 3.3-0.5 4.1-1.4 0.8-1 1.2-2.7 1.2-5.3v-29.5c0-2.9-0.4-4.9-1.2-6.2 -0.8-1.3-2.1-2-4.1-2v-2c2 0.2 3.9 0.3 5.8 0.3 6.5 0 11.9-0.4 16.2-1.3v6.7c2.8-4.7 7.7-7 14.8-7C499 41.8 502.5 43 504.5 45.5z'
        />
        <path
            d='M530.3 21.3h1.9V83.7c0 1.9 0.6 3.3 1.7 4.4 1.1 1.1 2.7 1.6 4.6 1.6 0.7 0 1.5-0.1 2.5-0.2 1-0.2 1.9-0.4 2.7-0.6l0.7 1.5c-0.9 0.3-2 0.6-3.3 0.8 -1.3 0.2-2.4 0.3-3.3 0.3 -2.2 0-4.1-0.7-5.5-2.2 -1.4-1.4-2.1-3.3-2.1-5.7V21.3z'
        />
        <path
            d='M571.5 92c-3.3 0-6.3-0.7-9.2-2.1 -2.9-1.4-5.4-3.2-7.5-5.5 -2.1-2.3-3.8-5.1-5.1-8.2 -1.2-3.1-1.9-6.4-1.9-9.9 0-3.5 0.6-6.8 1.9-9.9 1.2-3.1 2.9-5.8 5.1-8.2 2.2-2.4 4.7-4.2 7.6-5.6 2.9-1.4 5.9-2.1 9.1-2.1 3.2 0 6.2 0.7 9.1 2.1 2.9 1.4 5.4 3.2 7.5 5.6 2.1 2.4 3.8 5.1 5.1 8.2 1.3 3.1 1.9 6.4 1.9 9.9 0 3.4-0.6 6.7-1.9 9.9 -1.2 3.1-2.9 5.9-5.1 8.2 -2.1 2.3-4.6 4.2-7.5 5.5C577.8 91.4 574.7 92 571.5 92zM549.8 66.6c0 3.2 0.6 6.2 1.7 9.1 1.1 2.9 2.7 5.4 4.6 7.5 1.9 2.1 4.2 3.8 6.8 5.1 2.6 1.2 5.4 1.9 8.4 1.9 2.9 0 5.7-0.6 8.4-1.9 2.6-1.3 5-3 7-5.2 2-2.2 3.6-4.7 4.7-7.6 1.1-2.9 1.7-5.9 1.7-9.2 0-3.2-0.6-6.2-1.7-9.1 -1.1-2.9-2.7-5.4-4.7-7.6 -2-2.2-4.3-3.9-6.9-5.2 -2.6-1.3-5.4-1.9-8.4-1.9 -2.9 0-5.7 0.6-8.4 1.9 -2.6 1.3-5 3-6.9 5.2 -2 2.2-3.5 4.8-4.7 7.7C550.4 60.3 549.8 63.3 549.8 66.6z'
        />
        <path
            d='M621.8 91.1l-21.6-49.6h2.1l20.4 46.9 20.4-46.9h2.1l-21.6 49.6H621.8z'
        />
        <path
            d='M674.1 92c-3.3 0-6.3-0.7-9.2-2.1 -2.9-1.4-5.4-3.3-7.6-5.6 -2.2-2.4-3.9-5.2-5.2-8.3 -1.3-3.2-1.9-6.5-1.9-10.1 0-3.5 0.6-6.8 1.8-9.9 1.2-3.1 2.9-5.7 5-8s4.6-4.1 7.5-5.4c2.8-1.3 5.9-2 9.1-2 3.3 0 6.4 0.7 9.3 2 2.9 1.3 5.4 3.2 7.6 5.5s3.8 5 5.1 8.1c1.3 3.1 1.9 6.5 1.9 10v1.1h-45.4c0.3 3.2 1 6.2 2.2 8.9s2.9 5.2 4.8 7.2c2 2 4.3 3.7 6.8 4.8 2.6 1.2 5.3 1.8 8.2 1.8 1.9 0 3.8-0.3 5.6-0.8 1.8-0.5 3.5-1.2 5.1-2.2 1.6-0.9 3-2 4.2-3.3 1.2-1.3 2.2-2.7 2.9-4.2l1.8 0.5c-0.7 1.7-1.7 3.3-3 4.7 -1.3 1.4-2.8 2.7-4.6 3.7s-3.7 1.9-5.7 2.5S676.3 92 674.1 92zM695.6 65.4c-0.2-3.3-0.9-6.4-2.1-9.2 -1.2-2.8-2.8-5.2-4.7-7.2 -1.9-2-4.2-3.6-6.7-4.7 -2.6-1.1-5.3-1.7-8.2-1.7s-5.7 0.6-8.2 1.7c-2.6 1.1-4.8 2.7-6.7 4.8 -1.9 2-3.5 4.5-4.6 7.3 -1.1 2.8-1.8 5.8-2 9.1H695.6z'
        />
        <path
            d='M226.2 79.5c0.6-2.1 1.6-3.1 3.2-3.1 1 0 1.8 0.3 2.4 0.9 0.7 0.6 1 1.4 1 2.4 0 1.1-0.4 2.4-1.3 3.9 -0.2 0.3-1 1.4-2.5 3.4 -0.2 0.3-0.6 1-1.3 2.1 -0.6 0.9-1 1.6-1.5 2h-0.1c-0.3-0.3-0.6-0.6-0.8-1.1l-0.6-1.3c-0.3-0.7-1-1.6-2-2.8 -1.2-1.4-1.9-2.4-2.2-2.9 -0.7-1.1-1-2.2-1-3.2s0.3-1.8 1-2.4c0.7-0.6 1.5-1 2.4-1C224.6 76.4 225.7 77.4 226.2 79.5z'
        />
        <path
            d='M520.2 79.8c0.6-2.1 1.6-3.1 3.2-3.1 0.9 0 1.8 0.3 2.4 0.9 0.7 0.6 1 1.4 1 2.4 0 1.1-0.4 2.4-1.3 3.9 -0.2 0.3-1 1.4-2.5 3.4 -0.2 0.3-0.6 1-1.3 2.1 -0.6 0.9-1 1.6-1.5 2h-0.1c-0.3-0.3-0.6-0.6-0.8-1.1l-0.6-1.3c-0.3-0.7-1-1.6-2-2.8 -1.2-1.4-1.9-2.4-2.2-2.9 -0.7-1.1-1-2.2-1-3.2s0.3-1.8 1-2.4c0.7-0.6 1.5-1 2.4-1C518.5 76.7 519.6 77.7 520.2 79.8z'
        />
    </StyledLogo>
);

export const SchriftLogo = () => (
    <StyledLogoFlex>
        <Icon
            name='icon-scissors' width='2.25em' height='2em'
            iconColor='secondary.600' margin='0 0 -6px 0'
        />
        <StyledSchnoffle>Schnoffle</StyledSchnoffle>
    </StyledLogoFlex>
);

export const SchriftLogoWithSubLine = props => (
    <div {...props} >
        <StyledLogoFlex>
            <Icon
                name='icon-scissors' width='2.25em' height='2em'
                iconColor='secondary.600' margin='0 0 -6px 0'
            />
            <StyledSchnoffle>Schnoffle</StyledSchnoffle>
        </StyledLogoFlex>
        <StyledSubheadline>Näh Dir Dein Designerstück</StyledSubheadline>
    </div>
);

export default SchriftLogo;



// WEBPACK FOOTER //
// ./src/components/Logo.js